import { render, staticRenderFns } from "./ComboAdd.vue?vue&type=template&id=2e1d73f7&"
import script from "./ComboAdd.vue?vue&type=script&lang=js&"
export * from "./ComboAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports